import React from 'react'
import { getInfo } from 'SRC/modules/users/detail/selectors'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import config from 'SRC/config/config.json'
import { isUserOnline } from 'SRC/utils'
import translations from '../../../../../../public/data/translations.json'

const VehiclePartsHeaderMobile = ({ user }) => {
	const router = useRouter()

	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	if (!user) return null

	const banner = Array.isArray(user?.media) ? user?.media.find(item => item.title === "banner-image-2") : null

	return (
		<div className='vehicle-parts-header-mobile'>
			<div className='vehicle-parts-header-mobile__top'>
				<a href='javascript:void(0)' onClick={() => router.back()}>
					<ReactSVG src='/icons/back.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
					}} />
				</a>

				<a
					href='javascript:void(0)' onClick={() => {
						if (navigator.share) {
							navigator.share({
								title: 'NOVI DJELOVI - AUTO DILER',
								url: `https://autodiler.link/shop/${lang !== 'me' ? `${lang}/` : ''}${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`
							})
						}
					}}
					style={{
						float: 'right'
					}}
				>
					<ReactSVG src='/icons/share.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '25px')
						svg.setAttribute('height', '25px')
					}} />
				</a>
			</div>

			{banner && (
				<div className='vehicle-parts-header-mobile__banner'>
					<img width={1600} src={`${config.mediaCDN}${banner.fd}`} alt={user?.name || ''} />
				</div>
			)}

			<div className='vehicle-parts-header-mobile__info'>
				<p style={{ display: 'flex', alignItems: 'center', gap: '5px', lineHeight: 0, fontSize: '1rem' }}>
					<ReactSVG src='/icons/dostava.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '20px')
						svg.setAttribute('height', '20px')
						svg.querySelectorAll('path').forEach(path => {
							path.setAttribute('fill', '#0377cd')
						})
					}} />

					{t('dostava')}
				</p>

				<ReactSVG src='/icons/prodavnica-circle.svg' wrapper='span' className='vehicle-parts-header-mobile__info-circle' beforeInjection={svg => {
					svg.setAttribute('width', '5rem')
					svg.setAttribute('height', '5rem')
				}} />


				<div className='vehicle-parts-header-mobile-user-status'>
					<span className='user-online-status-text'>
						{isUserOnline(user?.active) ? `Online` : `Offline`} &nbsp;
						<span className={`user-online-status ${isUserOnline(user?.active) ? `online` : `offline`}`} />
					</span>
				</div>
			</div>

			<div className='vehicle-parts-header-mobile__title'>
				<h1>{t('auto djelovi').toUpperCase()} - AUTO DILER</h1>
				<p># E-COMMERCE</p>
			</div>

		</div>
	)
}

const mapStateToProps = (state) => ({
	user: getInfo(state)
})

export default connect(mapStateToProps)(VehiclePartsHeaderMobile)
